import React from 'react'

const App = () => (
    <div>
        <h2 className={"header2"}>400</h2>
        <h1 className={"header1"}>Bad request.</h1>
    </div> )
export default App
